import { LinkList } from '../components/link-list';
import { StepFrame } from '../components/step-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import type { ConsumerStepId } from '../lib/steps';
import type { ConsumerStepProps } from './step-props';

const CHANGES: { step: ConsumerStepId; title: string; description: string; returnTo?: ConsumerStepId }[] = [
  { step: 'options', title: 'My insurance option', description: 'How you pay, or which coverage.' },
  { step: 'scenario', title: 'My care scenario', description: 'Where care happens, how much care, and family help.', returnTo: 'review' },
  { step: 'household', title: 'Who is covered', description: 'Add or review a partner.', returnTo: 'review' },
];

export function ChangeStep({ clientId }: ConsumerStepProps) {
  const { goTo, back } = useConsumerFlow(clientId);

  return (
    <StepFrame
      step="change"
      title="What would you like to change?"
      subtitle="Choose one part. We’ll bring you back to your plan."
      onBack={() => back('review')}
      help={<p>Changing assumptions updates your plan, not a real policy.</p>}
      primary={{ label: 'Keep my current plan', onClick: () => back('review') }}
    >
      <LinkList
        entries={CHANGES.map(change => ({
          id: change.step,
          title: change.title,
          description: change.description,
          onSelect: () => goTo(change.step, { returnTo: change.returnTo }),
        }))}
      />
    </StepFrame>
  );
}
